<template>
  <div>
    <div class="grid grid--rev">
      <div class="grid__cell col5-of-12--large-up"></div>
      <div class="grid__cell col7-of-12--large-up">
        <div class="grid">
          <div class="grid__cell col12-of-12--medium-up">
            <p class="fw-bold fs-md mb-sm">URL Configuration</p>
            <div class="grid mb-lg">
              <div class="grid__cell col10-of-12--medium-up">
                <label class="url-input">
                  ParterPage Subdomain URL
                  <input
                    data-hj-allow
                    type="text"
                    name="subdomain"
                    @change="
                      updateSettings({
                        key: 'partnerpageUrl',
                        value: $event.target.value,
                      })
                    "
                    :value="
                      directorySettings ? directorySettings.partnerpageUrl : ''
                    "
                  />
                  <span class="url-input__suffix">.partnerpage.io</span>
                </label>
              </div>
            </div>
          </div>
          <div class="grid__cell col12-of-12--medium-up">
            <div class="grid mb-lg">
              <div class="grid__cell col10-of-12--medium-up">
                <label>
                  Branded custom domain via your DNS
                  <input
                    data-hj-allow
                    type="text"
                    name="customDomain"
                    :value="
                      directorySettings ? directorySettings.customDomain : ''
                    "
                    @change="checkURL($event.target.value)"
                  />
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="grid__cell col12-of-12--medium-up">
            <p class="fw-bold fs-md mb-sm">Images</p>
            <label class="is-required">Logo</label>
            <div class="grid mb-lg">
              <div class="grid__cell col10-of-12--medium-up">
                <FileUploadZone
                  @update-image="updateImage"
                  :existingImg="branding ? branding.logo : undefined"
                  field="logo"
                  zone-text="Upload or drop here your logo"
                  help-text="A version of your logo for your Partner Card and Partner Page,
                  designed for a white background. It would be great if it has the following specs:
                  transparent PNG image and 280px width / 140px height."
                  accept=".png, .jpg, .jpeg, .gif"
                ></FileUploadZone>
              </div>
            </div>
          </div>
          <div class="grid__cell col12-of-12--medium-up">
            <label class="is-required">Favicon</label>
            <div class="grid mb-lg">
              <div class="grid__cell col10-of-12--medium-up">
                <FileUploadZone
                  :existingImg="branding ? branding.favicon : undefined"
                  @update-image="updateImage"
                  field="favicon"
                  zone-text="Upload or drop here your logo"
                  help-text="For best results, use 32x32 images."
                  accept=".png, .jpg, .jpeg, .gif"
                ></FileUploadZone>
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="grid__cell col12-of-12--medium-up">
            <p class="fw-bold fs-md mb-sm">Colors</p>
            <div class="grid mb-lg">
              <div class="grid__cell col6-of-12--medium-up">
                <ColorInput
                  @changeColor="updateBranding"
                  input-name="actionPrimaryColor"
                  :value="branding ? branding.actionPrimaryColor : ''"
                  label="Primary Color"
                  help-text="Color for buttons and links."
                ></ColorInput>
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="grid__cell col12-of-12--medium-up">
            <p class="fw-bold fs-md mb-sm">Custom HTML</p>
            <label>
              Navbar Section HTML
              <textarea
                data-hj-allow
                :value="branding ? branding.customNavbarSection : ''"
                @change="
                  updateBranding({
                    key: 'customNavbarSection',
                    value: $event.target.value,
                  })
                "
                name="name"
                rows="8"
                cols="80"
                placeholder
              ></textarea>
            </label>
            <label>
              Hero Banner Section HTML
              <textarea
                data-hj-allow
                :value="branding ? branding.customHeroSection : ''"
                @change="
                  updateBranding({
                    key: 'customHeroSection',
                    value: $event.target.value,
                  })
                "
                name="name"
                rows="8"
                cols="80"
                placeholder
              ></textarea>
            </label>
          </div>
        </div>
        <div class="grid">
          <div class="grid__cell col12-of-12--medium-up">
            <p class="fw-bold fs-md mb-sm">Custom CSS</p>
            <label>
              <textarea
                data-hj-allow
                :value="branding ? branding.privateCustomCss : ''"
                name="name"
                @change="
                  updateBranding({
                    key: 'privateCustomCss',
                    value: $event.target.value,
                  })
                "
                rows="8"
                cols="80"
                placeholder
              ></textarea>
            </label>
          </div>
        </div>
        <div class="grid">
          <div class="grid__cell col12-of-12--medium-up">
            <p class="fw-bold fs-md mb-sm">Custom JS</p>
            <label>
              <textarea
                data-hj-allow
                name="name"
                :value="branding ? branding.customJs : ''"
                @change="
                  updateBranding({
                    key: 'customJs',
                    value: $event.target.value,
                  })
                "
                rows="8"
                cols="80"
                placeholder="You can add multiple scripts here."
              ></textarea>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColorInput from '@/components/Dashboard/ColorInput';
import FileUploadZone from '@/components/Dashboard/FileUploadZone';
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapGetters } = createNamespacedHelpers('directorySettings');

export default {
  components: {
    ColorInput,
    FileUploadZone,
  },
  computed: {
    ...mapGetters(['directorySettings', 'branding']),
  },
  methods: {
    ...mapActions([
      'fetchDirectorySettings',
      'fetchBranding',
      'updateSettings',
      'updateBranding',
      'updateImage',
    ]),

    checkURL(value) {
      if (!value) {
        this.updateSettings({ key: 'customDomain', value: '' });
        return;
      }

      if (!value.includes('http')) {
        value = 'https://' + value;
      }
      this.updateSettings({ key: 'customDomain', value });
    },
  },
};
</script>
